const API_PATH = '/api/studio-trusts';

async function request(method = 'GET', body = null) {
  const response = await fetch(API_PATH, {
    method,
    credentials: 'same-origin',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.error || `Trust directory service returned ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return payload;
}

export function loadAccessibleTrusts() {
  return request();
}

export function createTrustProfile(trust) {
  return request('POST', trust);
}

export function importLegacyTrustProfile(trust) {
  return request('POST', { ...trust, legacyImport: true });
}

export function setTrustActiveState(trustId, active) {
  return request('PATCH', { trustId, active });
}

export function setTrustJourneyLimit(trustId, journeyLimit) {
  return request('PATCH', { trustId, journeyLimit: journeyLimit === '' ? null : Number(journeyLimit) });
}

export function setTrustPrintEntitlements(trustId, licensedJourneyIds, easyReadPdfJourneyIds) {
  return request('PATCH', { trustId, licensedJourneyIds, easyReadPdfJourneyIds });
}

export async function resetNHNNSetup(expectedUpdatedAt) {
  const response = await fetch('/api/studio-nhnn-setup-reset', {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      trustId: 'nhnn_uclh',
      confirmation: 'nhnn_uclh',
      scope: 'pre-pilot-kyh-uniforms',
      expectedUpdatedAt,
    }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.ok !== true) throw new Error(payload.error || 'NHNN reset was not completed');
  return payload;
}

export function deleteTrustProfile(trustId, confirmTrustId) {
  return request('DELETE', { trustId, confirmTrustId });
}

export function mergeTrustDirectory(...directories) {
  const merged = new Map();
  directories.flat().filter(Boolean).forEach((trust) => {
    if (!trust.id) return;
    merged.set(trust.id, { ...merged.get(trust.id), ...trust });
  });
  return [...merged.values()].sort((a, b) => (a.shortName || a.name).localeCompare(b.shortName || b.name));
}
